import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ColorV2 } from "config/colors";
import "react-tooltip/dist/react-tooltip.css";
import {
  Text,
  ClockStampCreateAutoGeneratedGigBody,
  ClockStampModalHeader,
  Row,
  Container1,
  Container2,
  Container3,
} from "./clockStamp.styled";
import { Modal } from "@material-ui/core";
import { TimeReportForStamping, TimeReportsForStamping } from "model/Company";
import moment from "moment-timezone";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";

type Props = {
  setShowChooseTimeReportModal: React.Dispatch<React.SetStateAction<boolean>>;
  setKeyShouldBeDisabled: React.Dispatch<React.SetStateAction<boolean>>;
  showChooseTimeReportModal: boolean;
  setTimeReport: React.Dispatch<
    React.SetStateAction<TimeReportForStamping | undefined>
  >;
  clearInputs: () => void;
  handleCheckInCheckOut: () => void;
  timeReport: TimeReportForStamping | undefined;
  workerTimeReports: TimeReportsForStamping | null;
};

export const ClockStampChooseTimeReportModal: React.FC<Props> = ({
  setShowChooseTimeReportModal,
  setKeyShouldBeDisabled,
  showChooseTimeReportModal,
  setTimeReport,
  clearInputs,
  handleCheckInCheckOut,
  timeReport,
  workerTimeReports,
}) => {
  const { t } = useTranslation();

  const handleCloseModal = () => {
    setShowChooseTimeReportModal(false);
    setKeyShouldBeDisabled(false);
    clearInputs();
  };

  const formatTime = (time?: string | null) => {
    if (!time) return "—";
    return moment.tz(time, "UTC").tz("Europe/Stockholm").format("HH:mm");
  };

  const formatDate = (time: string) => {
    return moment.tz(time, "UTC").tz("Europe/Stockholm").format("YYYY-MM-DD");
  };

  useEffect(() => {
    if (timeReport !== undefined) {
      handleCheckInCheckOut();
    }
  }, [timeReport]);

  return (
    <>
      <Modal
        open={showChooseTimeReportModal}
        onClose={handleCloseModal}
        aria-labelledby="choose-time-report-title"
        aria-describedby="choose-time-report-description"
      >
        <ClockStampCreateAutoGeneratedGigBody>
          <ClockStampModalHeader>
            <Text
              id="choose-time-report-title"
              typography="h3"
              color={ColorV2.Blue1}
            >
              {t("StampClock.ChooseTimeReportForStamping")}
            </Text>
            <SecondaryButton
              iconName="v2/cross"
              aria-label={t("DesignComponents.CloseModal")}
              size="small"
              onClick={handleCloseModal}
            />
          </ClockStampModalHeader>

          <Text
            id="choose-time-report-description"
            typography="b1"
            color={ColorV2.Blue1}
          >
            {t("StampClock.ChooseTimeReportForStampingInfo")}
          </Text>

          {workerTimeReports &&
            workerTimeReports?.timeReports.map((tr) => {
              return (
                <Row key={tr.timeReportId}>
                  <Container1>
                    <Text typography="b1" color={ColorV2.Blue1}>
                      {formatDate(tr.startTime)}
                    </Text>
                  </Container1>

                  <Container2>
                    <Text typography="b1" color={ColorV2.Blue1}>
                      {`${formatTime(tr.startTime)}-${formatTime(tr.endTime)}`}
                    </Text>
                  </Container2>

                  <Container3>
                    <SecondaryButton
                      label={
                        tr.checkInTime == null
                          ? t("StampClock.CheckIn")
                          : t("StampClock.CheckOut")
                      }
                      size="small"
                      onClick={() => {
                        if (!workerTimeReports) return;
                        const selected: TimeReportForStamping = {
                          ...tr,
                          companyId: workerTimeReports.companyId,
                          workerPhoneNumber:
                            workerTimeReports.workerPhoneNumber,
                          };
                        setTimeReport(selected);
                      }}
                    />
                  </Container3>
                </Row>
              );
            })}
        </ClockStampCreateAutoGeneratedGigBody>
      </Modal>
    </>
  );
};
